import clsx from 'clsx'
import { Loader } from '@/components/Loader'
import { ButtonBase } from '../ButtonBase'
import { IVariantButtonProps } from '../types'
import styles from './styles.module.scss'

const ButtonOutline = ({
  children,
  className,
  isLoading,
  variant = 'default',
  ...props
}: IVariantButtonProps) => {
  return (
    <ButtonBase
      data-testid="mui-button-translucent"
      className={clsx(styles.translucent, styles[variant], className)}
      isLoading={isLoading}
      {...props}
    >
      {isLoading && <Loader className={clsx(styles.loader, styles[variant])} />}
      {children}
    </ButtonBase>
  )
}

export default ButtonOutline
